import RouteWithSubroutes from './route-with-subroutes';
import './route-with-subroutes.scss';

export default RouteWithSubroutes;
